module.exports = __webpack_public_path__ + "static/img/header_bg_coffee.png";